@if (hasPageOne) { <print-page-one [today]="today" [isDemo]="isDemo" /> }
@if (hasPageTwo) { <print-page-two [today]="today" [isDemo]="isDemo" /> }
@if (hasPageThree) { <print-page-three [today]="today" [isDemo]="isDemo" /> }